/** Interface strings of the operator console "Logs" tab. */
export const adminLogsMessages = {
  "admin.tabs.logs": { ru: "Логи", en: "Logs" },
  "admin.denied.logs": {
    ru: "У вашей сессии нет права observability.trace.read, поэтому логи недоступны.",
    en: "Your session lacks the observability.trace.read permission, so logs are unavailable.",
  },
  "admin.logs.title": { ru: "Логи вызовов", en: "Call logs" },
  "admin.logs.notice": {
    ru: "Один вызов - это все строки лога с общим correlation id.",
    en: "One call is every log line that shares a correlation id.",
  },
  "admin.logs.filter.user": { ru: "ID пользователя", en: "User ID" },
  "admin.logs.filter.session": { ru: "ID сессии", en: "Session ID" },
  "admin.logs.filter.range": { ru: "Период", en: "Time range" },
  "admin.logs.filter.apply": { ru: "Применить", en: "Apply" },
  "admin.logs.filter.clear": { ru: "Сбросить", en: "Clear" },
  "admin.logs.range.15m": { ru: "15 мин", en: "15 min" },
  "admin.logs.range.1h": { ru: "1 час", en: "1 hour" },
  "admin.logs.range.6h": { ru: "6 часов", en: "6 hours" },
  "admin.logs.range.24h": { ru: "24 часа", en: "24 hours" },
  "admin.logs.invalid": {
    ru: "Некорректный идентификатор в фильтре.",
    en: "A filter identifier is not valid.",
  },
  "admin.logs.unavailable": {
    ru: "Хранилище логов не настроено, поэтому логи недоступны.",
    en: "The log store is not configured, so logs are unavailable.",
  },
  "admin.logs.list.caption": { ru: "Список вызовов", en: "Call list" },
  "admin.logs.col.time": { ru: "Время", en: "Time" },
  "admin.logs.col.service": { ru: "Сервис", en: "Service" },
  "admin.logs.col.entry": { ru: "Входное событие", en: "Entry event" },
  "admin.logs.col.outcome": { ru: "Итог", en: "Outcome" },
  "admin.logs.col.duration": { ru: "Длительность", en: "Duration" },
  "admin.logs.col.errors": { ru: "Ошибок", en: "Errors" },
  "admin.logs.col.lines": { ru: "Строк", en: "Lines" },
  "admin.logs.empty": {
    ru: "Вызовов за выбранный период нет.",
    en: "No calls in the selected range.",
  },
  "admin.logs.loading": { ru: "Загрузка логов", en: "Loading logs" },
  "admin.logs.failed": {
    ru: "Не удалось загрузить логи.",
    en: "Logs could not be loaded.",
  },
  "admin.logs.more": { ru: "Показать ещё", en: "Load more" },
  "admin.logs.open": { ru: "Открыть", en: "Open" },
  "admin.logs.back": { ru: "К списку вызовов", en: "Back to calls" },
  "admin.logs.previous": { ru: "Предыдущий вызов", en: "Previous call" },
  "admin.logs.next": { ru: "Следующий вызов", en: "Next call" },
  "admin.logs.detail.loading": { ru: "Загрузка вызова", en: "Loading call" },
  "admin.logs.detail.failed": {
    ru: "Не удалось загрузить вызов.",
    en: "The call could not be loaded.",
  },
  "admin.logs.detail.notFound": {
    ru: "Вызов не найден в логах за последние 24 часа.",
    en: "The call was not found in the last 24 hours of logs.",
  },
  "admin.logs.detail.callId": { ru: "ID", en: "ID" },
  "admin.logs.detail.copy": { ru: "Копировать", en: "Copy" },
  "admin.logs.detail.copied": { ru: "Скопировано", en: "Copied" },
  "admin.logs.timeline.caption": {
    ru: "Хронология вызова",
    en: "Call timeline",
  },
  "admin.logs.timeline.empty": {
    ru: "В вызове нет строк.",
    en: "The call has no lines.",
  },
  "admin.logs.timeline.expand": { ru: "Подробнее", en: "Details" },
  "admin.logs.timeline.collapse": { ru: "Скрыть", en: "Hide" },
  "admin.logs.timeline.col.time": { ru: "Время", en: "Time" },
  "admin.logs.timeline.col.service": { ru: "Сервис", en: "Service" },
  "admin.logs.timeline.col.level": { ru: "Уровень", en: "Level" },
  "admin.logs.timeline.col.event": { ru: "Событие", en: "Event" },
  "admin.logs.timeline.col.operation": { ru: "Операция", en: "Operation" },
  "admin.logs.timeline.col.outcome": { ru: "Итог", en: "Outcome" },
  "admin.logs.timeline.col.code": { ru: "Код", en: "Code" },
  "admin.logs.timeline.col.duration": { ru: "Длительность", en: "Duration" },
  "admin.logs.timeline.col.model": {
    ru: "Провайдер / модель",
    en: "Provider / model",
  },
  "admin.logs.timeline.col.tokens": {
    ru: "Токены вх. / исх.",
    en: "Tokens in / out",
  },
  "admin.logs.timeline.col.http": { ru: "HTTP", en: "HTTP" },
  "admin.logs.field.message": { ru: "Сообщение", en: "Message" },
  "admin.logs.field.correlation_id": {
    ru: "Correlation ID",
    en: "Correlation ID",
  },
  "admin.logs.field.job_id": { ru: "Задание", en: "Job ID" },
  "admin.logs.field.session_id": { ru: "Сессия", en: "Session ID" },
  "admin.logs.field.turn_id": { ru: "Ход", en: "Turn ID" },
  "admin.logs.field.user_id": { ru: "Пользователь", en: "User ID" },
  "admin.logs.field.extra": { ru: "Дополнительно", en: "Extra" },
} as const;
